<template>
  <v-card>
    <v-card-text>
      <v-layout row wrap>
        <v-flex xs12 pb-0>
          <h3><b>{{$t('design.opacity')}}</b></h3>
        </v-flex>

        <v-flex
          xs12
          pt-1
          pb-0
        >
          <v-text-field
            v-bind:value="states[index].opacity"
            name="opacity"
            id="opacity"
            type="number"
            min="0"
            max="100"
            placeholder="0 - 100"
            @change="updateOpacity($event, index)"
          ></v-text-field>
        </v-flex>

        <v-flex xs12 pt-1 pb-0>
          <h3><b>{{$t('design.position')}}</b></h3>
        </v-flex>

        <v-flex
          xs12
          pt-1
          pb-0
        >
          <v-tooltip bottom>
            <v-btn
              color="accent"
              slot="activator"
              block
              @click.stop="updatePosition(index)"
            >
              <v-icon>pin_drop</v-icon>
            </v-btn>
            <span>Current position:</span>
            <span>X: {{states[index].positionX}}</span>
            <span>Y: {{states[index].positionY}}</span>
          </v-tooltip>
        </v-flex>

        <v-flex xs12 pt-1 pb-0>
          <h3><b>{{$tc('design.time', 1)}}</b></h3>
        </v-flex>

        <v-flex
          xs12
          pt-1
          pb-0
        >
          <drop
            @dragenter="timeIsHovering = true"
            @dragleave="timeIsHovering = false"
            @drop="updateTime(index)"
          >
            <v-tooltip bottom>
              <v-btn
                slot="activator"
                color="accent"
                v-bind:class="{
                  'animated infinite pulse': isDragging && !timeIsHovering,
                  'animated infinite tada': timeIsHovering,
                }"
                block
                :outline="!timeIsDropped"
              >
                <v-icon v-show="!timeIsDropped">hourglass_empty</v-icon>
                <v-icon v-show="timeIsDropped">hourglass_full</v-icon>
              </v-btn>
              <span>Current time: {{states[index].time}} seconds</span>
            </v-tooltip>
          </drop>
        </v-flex>
      </v-layout>
    </v-card-text>
  </v-card>
</template>

<script>
import { Drop } from 'vue-drag-drop';
import { mapWidgets } from './WidgetPropertiesUtils';

export default {
  components: {
    Drop,
  },
  computed: {
    id: {
      get() {
        return this.$store.getters.getActiveWidget;
      },
    },
    activeTimelinePoint: {
      get() {
        return this.$store.getters.getActiveTimelinePoint;
      },
    },
    ...mapWidgets(
      [
        {
          path: 'data',
          key: 'states',
        },
        {
          path: 'style',
          key: 'w',
        },
        {
          path: 'style',
          key: 'h',
        },
        {
          path: 'style',
          key: 'x',
        },
        {
          path: 'style',
          key: 'y',
        },
        {
          path: 'style',
          key: 'r',
        },
      ],
    ),
  },
  props: {
    index: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      currentState: null,
      timeIsHovering: false,
      timeIsDropped: false,
      isDragging: false,
    };
  },
  mounted() {
    if (this.states[this.index].time !== null) {
      this.timeIsDropped = true;
    }
  },
  watch: {
    activeTimelinePoint(timelinePointIndex) {
      if (timelinePointIndex !== null) {
        this.isDragging = true;
      } else {
        this.isDragging = false;
      }
    },
  },
  methods: {
    setCurrentState(index) {
      this.currentState = index;
    },
    updatePosition(index) {
      this.setCurrentState(index);

      const payload = {
        data: [
          {
            index: this.currentState,
            key: 'positionX',
            value: this.x,
          },
          {
            index: this.currentState,
            key: 'positionY',
            value: this.y,
          },
          {
            index: this.currentState,
            key: 'rotation',
            value: this.r,
          },
        ],
      };

      this.$store.dispatch(`widget${this.id}/UPDATE_STATE`, payload);
      this.$toasted.show('Position successfully set', { duration: 3000, singleton: true, type: 'success' });
    },
    updateTime(index) {
      this.setCurrentState(index);
      const activePoint = this.$store.getters.getTimelinePointByIndex(
        this.$store.getters.getActiveTimelinePoint,
      );

      if (activePoint !== undefined) {
        const payload = {
          data: [
            {
              index: this.currentState,
              key: 'timelinePointID',
              value: activePoint.id,
            },
            {
              index: this.currentState,
              key: 'time',
              value: activePoint.time,
            },
          ],
        };

        this.$store.dispatch(`widget${this.id}/UPDATE_STATE`, payload);
        this.$toasted.show('Time successfully set', { duration: 3000, singleton: true, type: 'success' });
        this.timeIsDropped = true;
        this.timeIsHovering = false;
      } else {
        this.$toasted.show('No timeline point selected. Please select timeline point first.', { duration: 3000, singleton: true, type: 'error' });
      }
    },
    updateOpacity(value, index) {
      this.setCurrentState(index);

      const payload = {
        data: [
          {
            index: this.currentState,
            key: 'opacity',
            value,
          },
        ],
      };

      this.$store.dispatch(`widget${this.id}/UPDATE_STATE`, payload);
      this.$toasted.show('Opacity successfully set', { duration: 3000, singleton: true, type: 'success' });
    },
  },
};
</script>

<style scoped>

</style>
